import React from 'react'
import EmbedNode from '../EmbedNode'

export default function GoogleDocsNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='docs.google.com' className='' text='Google Docs Link' transformUrl={(url) => (url.includes('?')&&!url.includes('embedded=true'))? url+'&embedded=true':url+'?embedded=true'} id={id} data={data} selected={selected} {...props} />
    )
}
